module.exports = __webpack_public_path__ + "img/dushaoyi.52894a91.jpg";